var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-container-wrap" }, [
    _c("div", { staticClass: "common-modal" }, [
      _vm.showBg && _vm.isBgExist
        ? _c("div", { staticClass: "modal-bg", on: { click: _vm.hideModal } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { ref: "modalContent", staticClass: "modal-content" },
        [
          _vm._t("header", [
            _c("div", { staticClass: "common-modal-header" }, [
              _c("h3", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "common-modal-body" },
            [_vm._t("default")],
            2
          ),
          _vm._v(" "),
          _vm._t("footer", [
            _c("div", { staticClass: "common-modal-footer" }, [
              _c("button", { on: { click: _vm.onCancel } }, [_vm._v("取消")]),
              _vm._v(" "),
              _c(
                "button",
                { staticClass: "primary", on: { click: _vm.onOk } },
                [_vm._v("确定")]
              )
            ])
          ])
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }